import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import MDBox from 'components/MDBox';

const steps = [
  'Create Ticket (FMC)',
  'Pending FM-Ops Verification',
  'Pending BSD Approval',
  'Approved',
];

const ProgressSectionSpaceAsset = (props) => {

  const { activeStep } = props
  const boxStyles = {
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-2rem"
  }

  return (
    <MDBox sx={boxStyles}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </MDBox>
  );
}

export default ProgressSectionSpaceAsset

ProgressSectionSpaceAsset.defaultProps = {
    activeStep: 1
}